import { useEffect, useState } from 'react';
import { fetchDataSources } from '../../data/variablesDataApi';

export const useFetchDatasources = () => {
	const [isDatasourcesFetched, setIsDatasourcesFetched] = useState(false);
	const [dataSources, setDatasources] = useState([]);
	useEffect(() => {
		const onMount = async () => {
			const response = await fetchDataSources();
			const mappedDataSources = response.map(d => {
				const dataSourceOption: any = { ...d };
				dataSourceOption.label = d.connectionName;
				dataSourceOption.value = d.connectionRID;
				return dataSourceOption;
			});
			setDatasources(mappedDataSources);
			setIsDatasourcesFetched(true);
		};

		onMount();
	}, []);

	return { isDatasourcesFetched, dataSources };
};
